'use strict';

angular
    .module('util.trsthumb', [])
    .directive('trsThumbContainer', [
        function() {
            return {
                restrict: 'EA',
                scope: {},
                controller: [
                    '$scope',
                    function($scope) {
                        var ctrl = this;

                        ctrl.setSelectedThumb = function(thumb) {
                            $scope.selectedThumb = thumb;
                        };

                        ctrl.getSelectedThumb = function() {
                            return $scope.selectedThumb;
                        };
                    },
                ],
            };
        },
    ])

    .directive('trsThumb', [
        '$sce',
        '$timeout',
        'thumbTransform',

        function($sce, $timeout, thumbTransform) {
            return {
                restrict: 'EA',
                require: '^trsThumbContainer',
                templateUrl: './components/util/trsThumb/trsThumb.tpl.html',
                scope: {
                    item: '=',
                    delay: '=',
                },

                link: function($scope, $element, $attrs, $ctrl) {
                    let delay = 1000;
                    angular.isDefined($scope.delay)
                        ? $timeout(function() {
                            makeThumb();
                        }, delay)
                        : makeThumb();

                    /**
                     * [makeThumb 显示缩略图]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function makeThumb() {
                        var transformType = $attrs.transform;
                        var transform = thumbTransform.get(transformType);
                        $scope.thumb = transform($scope.item);

                        $scope.$watch('item.ALLIMG', function() {
                            $scope.thumb = transform($scope.item);
                        });
                        // 解决图集稿图片编辑和替换的问题
                        $scope.$watch('item.PERPICURL', function() {
                            $scope.thumb = transform($scope.item);
                        });
                        if (!$scope.thumb || !$scope.thumb.type) {
                            return false;
                        }
                        $scope.isSelected = function() {
                            return $ctrl.getSelectedThumb() == $scope.thumb;
                        };

                        $scope.toggleStatus = function() {
                            $scope.showimgFocus = true;
                            $ctrl.setSelectedThumb($scope.thumb);
                            $timeout(function() {
                                var $bigThumb = $element.find('.bigPreview');
                                if ($bigThumb.length < 1) {
                                    return false;
                                }
                                var boundingEle = $element[0].getBoundingClientRect();
                                if (boundingEle.top - 131 > $bigThumb.outerHeight() / 2) {
                                    $bigThumb.css({
                                        top: -$bigThumb.outerHeight() / 2 + 'px',
                                    });
                                } else {
                                    $bigThumb.css({
                                        top: -(boundingEle.top - 151) + 'px',
                                    });
                                }
                                fixZindex();
                                $element.find('.feedbackThumb .carousel-control').bind('click', function() {
                                    $('video').trigger('pause');
                                });
                            });
                        };
                    }

                    /**
                     * [fixZindex description] 修正浮层问题 当缩率图浮框打开，会被下拉菜单给遮住，没有办法，正将下拉菜单关掉
                     * @return {[type]} [description]
                     */
                    function fixZindex() {
                        var $singleSelects = $('body').find('trs-single-select');
                        $singleSelects.each(function() {
                            var theScope = $(this).data().$isolateScope;
                            if (theScope.status.expanded == true) {
                                theScope.close();
                            }
                        });
                    }
                    $scope.close = function(force) {
                        $scope.showimgFocus = false;
                    };
                    $scope.thumbClose = function(e) {
                        var element = e.target;
                        var w = $(element).width();
                        var h = $(element).height();
                        var x = (e.pageX - element.x - w / 2) * (w > h ? h / w : 1);
                        var y = (e.pageY - element.y - h / 2) * (h > w ? w / h : 1);
                        var direction = Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) % 4;
                        // var dirName = new Array('上方', '右侧', '下方', '左侧');
                        // console.log(dirName[direction] + '离开');
                        if (direction !== 3) {$scope.showimgFocus = false;}
                    };
                },
            };
        },
    ])
    .directive('autofitsize', [
        function() {
            return {
                restrict: 'A',
                link: function($scope, $element, $attrs) {
                    // 2022-02-11
                    // 这里加延时的原因：在渲染dom的过程中，出现了第二次数据的dom渲染完成，但是第一次数据的dom还未销毁，会导致滚动条的位置滑动到最底部。
                    // 一共有三种解决方法
                    // 1.在各自控制器的请求数据方法中第一部将数据先清空 =>{this.array= []}
                    // 2.在各自的html的ng-repeat 后加入 track by $index 这样数据会直接修改原来的dom 不会增高这个table高度
                    // 3.此处加延时（由于其他两种方法修改成本较大，因此取用这个方法）
                    setTimeout(() => {
                        var target = $element.closest($attrs.autofitsize);
                        var dstW = target.width();
                        var dstH = target.height();
                        var dstRate = dstW / dstH;

                        $element.load(function() {
                            var img = new Image();
                            img.src = $element.attr('src');
                            img.onload = function() {
                                var imgW = img.width;
                                var imgH = img.height;
                                var imgRate = imgW / imgH;

                                if (img.width < dstW && img.height < dstH) {
                                    $element.css({
                                        marginLeft: (dstW - imgW) / 2 + 'px',
                                        marginRight: (dstW - imgW) / 2 + 'px',
                                        marginTop: (dstH - imgH) / 2 + 'px',
                                        marginBottom: (dstH - imgH) / 2 + 'px',
                                        width: 'auto',
                                        height: 'auto',
                                    });
                                    return;
                                }

                                if (dstRate > imgRate) {
                                // 比較高
                                    $element.css({
                                        marginLeft: (dstW - imgRate * dstH) / 2 + 'px',
                                        marginRight: (dstW - imgRate * dstH) / 2 + 'px',
                                        width: 'auto',
                                        height: dstH + 'px',
                                    });
                                } else {
                                    $element.css({
                                        marginTop: (dstH - dstW / imgRate) / 2 + 'px',
                                        marginBottom: (dstH - dstW / imgRate) / 2 + 'px',
                                        width: dstW + 'px',
                                        height: 'auto',
                                    });
                                }
                            };
                        });
                    });
                },
            };
        },
    ])

/**
     * {
            type: 'video',
            imgUrl: '',//小的缩略图
            videoUrl : ''
        };
     * {
            type: 'audio',
            imgUrl: '',//小的缩略图
            audioUrl : ''
        };  
     * {
            type: 'image',
            imgUrl: '',//小的缩略图
            data: [{//多张图片
                    url: ''
                }
            ]
        };  
     */

    .factory('thumbTransform', function() {
        var cache = {};
        return {
            register: function(type, transform) {
                cache[type] = transform;
            },

            get: function(type) {
                return cache[type];
            },
        };
    })

    .run([
        '$sce',
        'thumbTransform',
        function($sce, thumbTransform) {
            thumbTransform.register('editingCenterThumb', function(input) {
                var item;

                if (input.METALOGOURL && input.METALOGOURL.VIDEOLOGO) {
                    item = {
                        type: 'video',
                        imgUrl: input.METALOGOURL.VIDEOLOGO2,
                        videoUrl: $sce.trustAsResourceUrl(input.METALOGOURL.VIDEOLOGO),
                    };
                } else if (input.METALOGOURL && input.METALOGOURL.AUDIOLOGO) {
                    item = {
                        type: 'audio',
                        imgUrl: input.METALOGOURL.AUDIOLOGO2,
                        audioUrl: $sce.trustAsResourceUrl(input.METALOGOURL.AUDIOLOGO),
                    };
                } else if (input.METALOGOURL && input.METALOGOURL.PICSLOGO) {
                    item = {
                        type: 'image',
                        imgUrl: input.METALOGOURL.PICSLOGO2,
                        data: [
                            {
                                url: input.METALOGOURL.PICSLOGO,
                            },
                        ],
                    };
                } else if (input.PERPICURL) {
                    item = {
                        type: 'image',
                        imgUrl: input.PERPICURL,
                        data: [
                            {
                                url: input.PERPICURL,
                            },
                        ],
                    };
                }

                return item;
            });
        },
    ])

    .run([
        '$sce',
        'thumbTransform',
        function($sce, thumbTransform) {
            thumbTransform.register('editingCenterAllThumb', function(input) {
                var item;
                var list = input.ALLIMG;
                if (input.METALOGOURL && input.METALOGOURL.VIDEOLOGO) {
                    item = {
                        type: 'video',
                        imgUrl: input.METALOGOURL.VIDEOLOGO2,
                        videoUrl: $sce.trustAsResourceUrl(input.METALOGOURL.VIDEOLOGO),
                    };
                } else if (input.METALOGOURL && input.METALOGOURL.AUDIOLOGO) {
                    item = {
                        type: 'audio',
                        imgUrl: input.METALOGOURL.AUDIOLOGO2,
                        audioUrl: $sce.trustAsResourceUrl(input.METALOGOURL.AUDIOLOGO),
                    };
                } else if (input.METALOGOURL && input.METALOGOURL.PICSLOGO) {
                    item = {
                        type: 'image',
                        imgUrl: input.METALOGOURL.PICSLOGO2,
                        data: [],
                    };

                    if (list && list.length > 0) {
                        angular.forEach(list, function(value, key) {
                            item.data.push({
                                url: value.PICSLOGO,
                            });
                        });
                    } else {
                        item.data = [
                            {
                                url: input.METALOGOURL.PICSLOGO,
                            },
                        ];
                    }
                } else if (input.PERPICURL) {
                    item = {
                        type: 'image',
                        imgUrl: input.PERPICURL,
                        data: [
                            {
                                url: input.PERPICURL,
                            },
                        ],
                    };
                }
                return item;
            });
        },
    ])
    .run([
        'thumbTransform',
        function(thumbTransform) {
            thumbTransform.register('resourceCenterThumb', function(input) {
                var item = {};
                var list = input.imgurl;
                item.type = list ? 'image' : '';
                item.data = [];

                if (angular.isArray(list)) {
                    angular.forEach(list, function(value, key) {
                        item.data.push({
                            url: value.urlM,
                        });
                    });
                } else if (angular.isObject(list) && !angular.isArray(list)) {
                    for (var name in list) {
                        var imgs = list[name] && list[name].split(',');
                        angular.forEach(imgs, function(value, key) {
                            if (value.urlM) {
                                arr.push({
                                    url: value.urlM,
                                });
                            }
                        });
                    }
                }

                item.imgUrl = (item.data[0] || {}).url || '';
                return item;
            });
        },
    ])
    .run([
        'thumbTransform',
        function(thumbTransform) {
            thumbTransform.register('planningCenterDetailThumb', function(input) {
                var item = {};
                var list = input.IMAGE_URL;
                item.type = list ? 'image' : '';
                item.data = [];

                if (angular.isArray(list)) {
                    angular.forEach(list, function(value, key) {
                        item.data.push({
                            url: value.urlM,
                        });
                    });
                } else if (angular.isObject(list) && !angular.isArray(list)) {
                    for (var name in list) {
                        var imgs = list[name] && list[name].split(',');
                        angular.forEach(imgs, function(value, key) {
                            if (value.urlM) {
                                arr.push({
                                    url: value.urlM,
                                });
                            }
                        });
                    }
                }

                item.imgUrl = (item.data[0] || {}).url || '';
                return item;
            });
        },
    ])
    .run([
        'thumbTransform',
        function(thumbTransform) {
            thumbTransform.register('tenantManuscriptThumb', function(input) {
                var item = {};
                var list = input.imgurl;
                item.type = list ? 'image' : '';
                item.data = [];

                if (angular.isArray(list)) {
                    angular.forEach(list, function(value, key) {
                        item.data.push({
                            url: value.appfile,
                        });
                    });
                } else if (angular.isObject(list) && !angular.isArray(list)) {
                    for (var name in list) {
                        var imgs = list[name] && list[name].split(',');
                        angular.forEach(imgs, function(value, key) {
                            if (value.urlM) {
                                arr.push({
                                    url: value.urlM,
                                });
                            }
                        });
                    }
                }

                item.imgUrl = (item.data[0] || {}).url || '';
                return item;
            });
        },
    ])
    // 意见反馈 图片和视频预览
    .run([
        '$sce',
        'thumbTransform',
        'trsHttpService',
        function($sce, thumbTransform, trsHttpService) {
            thumbTransform.register('feedbackThumb', function(input) {
                var item = {
                    type: 'AllType', // 图片和视频
                    data: [],
                };
                if (input.PICS && input.PICS.length > 0) {
                    var list = input.PICS;
                    angular.forEach(list, function(value, key) {
                        item.data.push({
                            type: 'image',
                            url: value.URL,
                        });
                    });
                    item.imgUrl = list[0].URL;
                }
                if (input.VIDEOIDS && input.VIDEOIDS.length > 0) {
                    input.VIDEOIDS.forEach((video) => {
                        var videoUrl = $sce.trustAsResourceUrl(video.DATA.videoUrl);
                        item.data.push({
                            type: 'video',
                            videoUrl: videoUrl,
                        });
                    });
                }
                return item;
            });
        },
    ]);
